export default __webpack_public_path__ + "static/media/julian_m.23a3e909.jpg";